module.exports = __webpack_public_path__ + "img/536.6385dd35.jpg";